import React from 'react';

function FormLayout({ children }) {
  return <div className="form-layout">{children}</div>;
}
export default FormLayout;
